import React from "react";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {Contact} from "./components/Contact";
import {Music} from "./components/Music";
import {Link} from "./components/Link";
import {Projects} from "./components/Projects";

function App() {
    return (<Router>
        <Routes>
            <Route path="/" element={<MainPage/>}/>
            <Route path="/music" element={<Music/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/portfolio" element={<Projects/>}/>
        </Routes>
    </Router>)
}

const MainPage = () => {
    return (<div className="relative min-h-screen select-none">
        <div className="grid h-[72vh] md:h-[90vh]">
            <div className="col-start-1 row-start-1 z-0 bg-[url('/background.jpg')] bg-cover bg-center"/>
            <div className="col-start-1 row-start-1 z-10 bg-black/20 md:bg-black/5"/>
            <div className="col-start-1 row-start-1 z-20 mt-36 md:mt-80 flex flex-col items-center px-4">
                <div className="rounded-2xl bg-black/25 px-4 py-4 backdrop-blur-[1px] md:rounded-none md:bg-transparent md:p-0 md:backdrop-blur-0">
                    <h1 className="m-0 text-center text-5xl font-medium uppercase tracking-[0.14em] text-white drop-shadow md:text-8xl md:font-light md:tracking-[0.2em]">
                        Tom Allton
                    </h1>
                    <h3 className="m-0 mt-2 text-center text-base font-semibold tracking-[0.04em] text-white drop-shadow md:mt-12 md:text-2xl md:font-medium md:tracking-widest">
                        Programmer / Designer / Creative
                    </h3>
                </div>
            </div>
        </div>
        <div className="mx-auto mb-0 w-11/12 text-xl font-light tracking-wide text-black md:w-3/5 md:text-3xl">
            <h5 className="my-8 text-3xl font-bold tracking-widest text-black md:text-5xl">About</h5>
            Hi, I'm Tom Allton. I'm creative director and software designer at{" "}
            <Link href="https://pokefind.co/">PokéFind</Link>,
            a Pokémon-inspired online multiplayer game.
            With over 2,000,000 unique players, it continues to grow using community based tools I developed.
            <Contact/>
        </div>
        <footer className="mb-2 ml-5 mt-24 text-left font-['Proxima_Nova_Alt_Light'] text-black">
            Copyright © Tom Allton {new Date().getFullYear()}. All Rights Reserved.
        </footer>
    </div>);
}

export default App;
